import React from "react";

import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Typography from "@material-ui/core/Typography";

import useStyles from "./css";
import { useTranslation, Trans } from "react-i18next";
import { UserContinueEditModalProps } from "./props";
import { CrossIcon, ExclamationIcon } from "../../../../../assets/icons";


export default function UserContinueEditModal(props: UserContinueEditModalProps) {
  
  const { open, setOpen, onSubmit, appointmentCount } = props;

  const classes = useStyles();
  const { t } = useTranslation("settings");

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    onSubmit();
    handleCloseModal();
  }

  const GoBackButton = () =>
    <Button
      className={`${classes.button} ${classes.goBackButton}`}
      onClick={handleCloseModal}
    >
      {t("Go back")}
    </Button>

  const SubmitButton = () =>
    <Button
      className={`${classes.button} ${classes.submitButton}`}
      onClick={handleSubmit}
    >
      {t("Save changes")}
    </Button>

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={handleCloseModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <div className={classes.paper}>
          <div className={classes.closeButton} onClick={handleCloseModal}>
            <CrossIcon />
          </div>
          <div className={classes.content}>
            <div className={classes.exclamationIcon}>
              <ExclamationIcon viewBox="0 0 7 16" />
            </div>
            <Typography className={classes.modalTitle}>
              {t("Continue with the new configuration?")}
            </Typography>
            <div className={classes.modalTextBlock}>
              <Typography className={classes.modalText}>
                <Trans i18nKey="ThereAreExistingAppointments" t={t} values={{ appointmentCount }} />
              </Typography>
              <Typography className={classes.modalText}>
                <Trans i18nKey="WeSuggestToMoveOrReassignThem" t={t} />
                <Trans i18nKey="DontForgetToNotify" t={t} />
              </Typography>
            </div>
            <div className={classes.modalFooter}>
              <GoBackButton />
              <SubmitButton />
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
}